import { useEffect, useState } from 'react';
import { View, Linking } from 'react-native';

import { Button, COLORS, Text, ButtonIcon } from '../Basics';
import { Screen } from '../../screens/Screen';

export const ScreenPopPanel = () => {
  const [visible, setVisible] = useState(false);
  const [url, setUrl] = useState('');
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    const onOpen = ev => {
      const data = ev.detail || ev.data;
      if (!data?.url) return;
      setUrl(data.url);
      setMeta(data);
      setVisible(true);
    };

    document.addEventListener('lorentz:screen-pop:open', onOpen);
    return () =>
      document.removeEventListener('lorentz:screen-pop:open', onOpen);
  }, []);

  const openExternal = () => {
    if (url) {
      try {
        Linking.openURL(url);
      } catch {
        window.open(url, '_blank');
      }
    }
  };

  if (!visible || !url) return null;

  return (
    <Screen
      visible
      closeable
      onClose={() => setVisible(false)}
      color={COLORS.app}
      style={{ zIndex: 900 }}
    >
      <View style={{ flex: 1, padding: 8 }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 8
          }}
        >
          <Text style={{ fontWeight: 'bold', fontSize: 16 }}>CRM / Screen pop</Text>
          <ButtonIcon icon="eye" onClick={openExternal} />
        </View>

        {meta?.phone || meta?.contact?.name || meta?.contact?.cpf ? (
          <Text style={{ color: COLORS.textSecondary, marginBottom: 8 }}>
            {[meta.contact?.name, meta.phone, meta.contact?.cpf ? `CPF ${meta.contact.cpf}` : null]
              .filter(Boolean)
              .join(' · ')}
          </Text>
        ) : null}

        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 360
          }}
        >
          <iframe
            title="screen-pop-crm"
            src={url}
            style={{
              flex: 1,
              width: '100%',
              height: '100%',
              border: `1px solid ${COLORS.borderColor}`,
              borderRadius: 6,
              minHeight: 360
            }}
          />
        </div>

        <View style={{ flexDirection: 'row', marginTop: 8 }}>
          <Button color="primary" onClick={openExternal} style={{ marginRight: 8 }}>
            <Text style={{ color: '#fff' }}>Abrir em nova aba</Text>
          </Button>
          <Button onClick={() => setVisible(false)}>
            <Text>Fechar</Text>
          </Button>
        </View>
      </View>
    </Screen>
  );
};

export default ScreenPopPanel;
